import React from 'react';
import Select, { components } from 'react-select';
import styled from 'styled-components';
import { colors } from './Styles';

export type RhSelectOption = {
  value: string;
  label: string;
  icon?: React.FC<React.SVGProps<SVGSVGElement>>;
};

export type RhGroupedOptions = {
  label: string;
  options: RhSelectOption[];
};

type Props = {
  options: RhSelectOption[] | RhGroupedOptions[];
  isSearchable?: boolean;
  isDisabled?: boolean;
  isLoading?: boolean;
  onChange?: (option: RhSelectOption) => void;
  value?: RhSelectOption | null;
  placeholder?: React.ReactNode;
  optionsStyle?: React.CSSProperties;
  containerSyle?: React.CSSProperties;
};

// NOTE: i have no idea how to properly type this
const Option = (props: any) => {
  const data = props.data as RhSelectOption;
  return (
    <components.Option {...props}>
      <Flexed>
        {data.icon && (
          <div>
            <data.icon fill={colors.normal} style={styles.icon} />
          </div>
        )}
        <div>{data.label}</div>
      </Flexed>
    </components.Option>
  );
};

// NOTE: same thing as above here :(
const SingleValue = (props: any) => {
  const data = props.data as RhSelectOption;
  return (
    <components.SingleValue {...props}>
      <Flexed>
        {data.icon && (
          <div style={{ height: '100%', display: 'flex' }}>
            <data.icon fill={colors.primary} style={styles.icon} />
          </div>
        )}
        <div>{props.children}</div>
      </Flexed>
    </components.SingleValue>
  );
};

export const RhSelect = (props: Props) => {
  const { isSearchable = true, isDisabled = false, isLoading = false } = props;
  return (
    <Select
      value={props.value}
      onChange={e => {
        if (!e) return;
        const value = e as RhSelectOption;
        props.onChange?.(value);
      }}
      isSearchable={isSearchable}
      isDisabled={isDisabled}
      isLoading={isLoading}
      defaultValue={props.options[0]}
      options={props.options}
      menuPortalTarget={document.body}
      menuShouldScrollIntoView={false}
      placeholder={props.placeholder}
      styles={{
        container: provided => ({
          ...provided,
          fontWeight: 600,
          fontSize: 14,
          ...props.containerSyle,
        }),
        control: provided => ({
          ...provided,
          borderRadius: 10,
          border: `1px solid ${colors.faintGrey}`,
        }),
        // this styling became weird-looking when i put menuPortalTarget
        // menu: provided => ({
        //   ...provided,
        //   borderRadius: 10,
        //   boxShadow: '0px 2px 5px 1px rgba(0, 0, 0, 0.25)',
        // }),
        option: (provided, state) => ({
          ...provided,
          backgroundColor: state.isSelected ? colors.highlight : '#fff',
          color: colors.normal,
          ...props.optionsStyle,
        }),
        indicatorSeparator: () => ({}),
      }}
      components={{
        Option,
        SingleValue,
      }}
    />
  );
};

const styles = {
  icon: {
    height: 20,
    width: 20,
  },
};

const Flexed = styled.div`
  display: flex;
  align-items: center;
  & > :not(:last-child) {
    margin-right: 10px;
  }
`;
